export default {
  optionsComment: '',
  optionsList: null,
  optionsListOriginal: null,
  optionsErrors: {
    calculate: false,
    inBasket: false,
  },
  optionWarning: {
    value: null,
    index: null,
  },
  isDisabledDlypr: false,
}
